import React, { useRef, useState } from 'react';
import JsBarcode from 'jsbarcode';
import QRCode from 'qrcode';
import { Alert } from "react-bootstrap"
// import './barcode.css';
import Dropzone from '../actions/Dropzone';
import { tailwindConfig } from '../../utils/Utils';
import axios from 'axios';

const Barcode = ({ instance, onFileReady }) => {
  const barcodeRef = useRef(null);
  const qrRef = useRef(null);
  const formatRef = useRef(null);
  
  const [error, setError] = useState("")

  const [errText, setErrText] = useState('');
  const [errQrText, setErrQrText] = useState('');
  const [qrInput, setQrInput] = useState('');
  const [program, setProgram] = useState('');
  const [documentType, setDocumentType] = useState('');
  const [generatedQr, setGeneratedQr] = useState('');

  const saveCertificate = async () => {
    try {
      let payload = { fullname: qrInput, program: program, document_type: documentType };

      // Go to backend folder routes/certificate.js
      let res = await axios.post('https://wadcas-be.herokuapp.com/certificate/add', payload);

      let data = res.data;
      saveSsa(data._id, data.fullname);

    } catch(err) {
      console.log(err);
      setError('Missing Fields')
    }
  }

const saveSsa = async (cert_id, fullname) => {
    let payload = { cert_id: cert_id, fullname: fullname };

    let res = await axios.post('https://wadcas-be.herokuapp.com/certificate/ssa/add', payload);

    let data = res.data;

    // set key one
    setGeneratedQr(data.keyOne);

    // create qr canvas
    QRCode.toCanvas(qrRef.current, data.keyOne, function (error) {
      if (error) setErrQrText(error);
    });

    // stamp qr
    stampBarcode('qr');
};

  const stampBarcode = (type) => {
    const { Annotations, annotManager, docViewer } = instance;
    const stampAnnot = new Annotations.StampAnnotation();
    stampAnnot.PageNumber = docViewer.getCurrentPage();
    stampAnnot.X = 100;
    stampAnnot.Y = 250;
    stampAnnot.Width = 300;
    
    if (type === '2d') {
      stampAnnot.ImageData = barcodeRef.current.toDataURL();
      stampAnnot.Height = 200;
    } else {
      stampAnnot.ImageData = qrRef.current.toDataURL();
      stampAnnot.Height = 300;
    }

    stampAnnot.Author = annotManager.getCurrentUser();
    annotManager.addAnnotation(stampAnnot);
    annotManager.redrawAnnotation(stampAnnot);
  };

  const onUpload = (file) => {
    onFileReady(file);
  }

  return (
  <div className="flex flex-col col-span-full sm:col-span-6 xl:col-span-4 bg-white shadow-lg rounded-sm border border-gray-200">
    <header className="px-5 py-4 border-b border-gray-100">
      <h4 className="font-semibold text-gray-800">Enter Values</h4>
    </header>
    
    

    <div class="flex flex-col pb-4">
      <button class="bg-gray-500 hover:bg-gray-700 text-white font-bold pl-4 pt-2 px-4 border border-blue-700 rounded">
        {/* Click add file */}
        <Dropzone onUpload={onUpload}/>
      </button>
    </div>

    {error && <Alert variant="danger">{error}</Alert>}

    <div class="flex flex-wrap px-5">
      <div class="w-full px-3">
        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold" for="grid-first-name">
          Enter Full Name
        </label>
        <input class="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-first-name" type="text" type="text"
          onChange={e => {
            setQrInput(e.currentTarget.value);
          }}
        />
      </div>
    </div>

    <div class="flex flex-wrap px-5 mb-6">
      <div class="w-full px-3">
      <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-last-name">
          Program
        </label>
        <input class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-last-name" type="text"
          onChange={e => {
            setProgram(e.currentTarget.value);
          }}
        />
      </div>
    </div>

    <div class="flex flex-wrap items-center px-5 mb-6">
      <div class="w-full px-3">
        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-last-name">
          Document Type
        </label>
        <input class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-last-name" type="text"
          onChange={e => {
            setDocumentType(e.currentTarget.value);
          }}
        />
      </div>

      <div class="w-full items-center px-3">
        <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold p-2 mt-4 ml-24 px-4 border border-blue-700 rounded" onClick={e => {saveCertificate();}}>
          Generate key
        </button>
      </div>
    </div>

    <div class="flex flex-wrap px-5 mb-6">
      <div class="w-full px-3">
      <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-last-name">
          Generated Key
        </label>
        <input class="appearance-none disabled block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" disabled="true" id="grid-last-name" type="text"
          value={generatedQr}
        />
      </div>
    </div>

    <div className="grid invisible pt-2 grid-cols-12 gap-6">
      <div class="col-span-full xl:col-span-4 pl-2">
        <div className="error">{errQrText}</div>
        <canvas className="qrCanvas" ref={qrRef}></canvas>
      </div>
    </div>

    
  </div>
  );
};

export default Barcode;
